import MenuItem from '@mui/material/MenuItem';

import { exportJSONToExcel } from 'src/utils/xlsx';

import { useTranslate } from 'src/locales';

import { Iconify } from 'src/components/iconify';

// ----------------------------------------------------------------------

export function ExportExcel({ data, ...props }) {
  const { hideMenu } = props;

  const { t } = useTranslate();

  const handleExport = () => {
    exportJSONToExcel({
      filename: `${t('promotions')}.xlsx`,
      headers: [
        [
          'id',
          'name',
          'code',
          'creation date',
          'category',
          'tags',
          'gender',
          'published',
          'free shipping',
          'currency',
          'price',
          'sale price',
          'taxes',
          'total sold',
          'total ratings',
          'total reviews',
          'long',
          'depth',
          'width',
          'weight',
          'quantity',
          'available',
          'inventory',
          'description',
          'sub description',
        ].map(t),
      ],
      data: data.map((item) => ({
        id: item.id,
        name: item.name,
        code: item.code,
        create: item.create,
        category: item.category,
        tags: item.tags.join(', '),
        gender: item.gender.join(', '),
        publish: item.publish,
        shipping: item.shipping,
        currency: item.currency,
        price: item.price,
        priceSale: item.priceSale,
        taxes: item.taxes,
        totalSales: item.totalSales,
        totalRating: item.totalRating,
        totalReviews: item.totalReviews,
        long: item.long,
        depth: item.depth,
        width: item.width,
        weight: item.weight,
        quantity: item.quantity,
        available: item.available,
        inventoryType: item.inventoryType,
        description: item.description,
        shortDescription: item.shortDescription,
      })),
    });
    hideMenu?.();
  };

  return (
    <MenuItem onClick={handleExport} sx={{ gap: 1 }}>
      <Iconify icon="vscode-icons:file-type-excel" />
      {t('Export Excel')}
    </MenuItem>
  );
}
